import { AttributesMixin, define, memberOf, Model, type } from "@type-r/models";
import { AssetType } from "./assetType";
import { restfulIO } from "./endpoint";
import { OptionItemBase } from "./lookups";

export interface ImportJob extends AttributesMixin<typeof ImportJob> { }
@define
export class ImportJob extends Model {
    static attributes = {
        jobId: Number,
        documentId: String,
        statusId: memberOf('store.importJobStatuses.items', OptionItemBase),
        assetTypeId: memberOf('store.assetTypes.items', OptionItemBase),
        importTemplateId: String,
        importTemplateName: String,
        isStandard: Boolean,
        errorInfo: [String],
        assetCount: Number,
        digitizedAssetCount: Number,
        fileCount: Number,
        initiatedOn: Date,
        processedOn: type(Date).null,
        isManual: Boolean,
        platformCode: String,
        createdBy: String,
        originalFileName: String,
        connectionId: type(Number).null,
        assetTypeNames: String,
        modifyExistingAssets: Boolean,
        updatedOn: type(Date).null
    }

    get hasErrors(): boolean {
        return this.errorInfo && (this.errorInfo as string[]).length > 0;
    }

    get errorMsg(): string {
        return this.hasErrors ? this.errorInfo[0] : null
    }

    get displayImportTemplateName(): string {
        return this.isStandard ? 'Standard' : this.importTemplateName;
    }

    get assetType(){
        return + this.assetTypeId.id as AssetType;
    }
}

export interface ImportJobs extends AttributesMixin<typeof ImportJobs> { }
@define
export class ImportJobs extends Model {
    static endpoint = restfulIO('api/v1/ingest/import-jobs');

    static attributes = {
        items: [ImportJob],
        count: Number
    }
}
